<template>
  <va-modal
    v-model="toOpenModal"
    :title="$t('modals.spot.title')"
    :hideDefaultActions="true"
    :noOutsideDismiss="true"
    :noEscDismiss="true"
  >
    <SwappingSquaresSpinner v-if="modalLoader"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <form v-if="!modalLoader">
      <div class="row">
        <va-select v-if="showLocation"
          style="margin-bottom: 15px;"
          :label="$t('modals.spot.selectLocation')"
          v-model="location"
          keyBy="eventId"
          textBy="name"
          :options="locations"
          :error="!!locationError.length"
          class="flex xs12"
        />
        <va-input
          v-model="spotName"
          type="text"
          :label="$t('modals.spot.inputClassification')"
          :placeholder="$t('modals.spot.placeholderClassification')"
          :error="!!spotNameErrors.length"
          :error-messages="spotNameErrors"
          class="flex xs12"
        />
        <va-input
          v-model="spotIdentifier"
          type="text"
          :label="$t('modals.spot.inputIdentifier')"
          :placeholder="$t('modals.spot.placeholderIdentifier')"
          :error="!!spotIdentifierErrors.length"
          :error-messages="spotIdentifierErrors"
          class="flex xs12"
        />
        <va-input
          v-model="spotAmount"
          type="number"
          :label="$t('modals.spot.inputAmount')"
          :placeholder="$t('modals.spot.placeholderAmount')"
          :error="!!spotAmountErrors.length"
          :error-messages="spotAmountErrors"
          class="flex xs12"
        />
        <va-input
          v-model="startFrom"
          type="number"
          :label="$t('modals.spot.inputStartFrom')"
          :placeholder="$t('modals.spot.placeholderStartFrom')"
          :error="!!spotStartFromErrors.length"
          :error-messages="spotStartFromErrors"
          class="flex xs12"
        />
        <fieldset>
          <va-checkbox
            :label="$t('modals.spot.checkboxStatic')"
            v-model="isStaticByDefault"
          />
        </fieldset>
      </div>
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click.prevent="closeModal()" class="my-0 ">{{ $t('modals.spot.btnClose') }}</va-button>
        <va-button type="submit" @click.prevent="onsubmit()" class="my-0">{{ $t('modals.spot.btnCreate') }}</va-button>
      </div>
    </form>
  </va-modal>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  name: 'SpotCreateModal',
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  data () {
    return {
      showLocation: false,
      locations: [],
      modalLoader: false,
      startFrom: '',
      spotName: '',
      spotIdentifier: '',
      spotAmount: '',
      isStaticByDefault: false,
      location: {},
      spotAmountErrors: [],
      spotNameErrors: [],
      spotIdentifierErrors: [],
      spotStartFromErrors: [],
      locationError: [],
    }
  },
  props: {
    locationId: Number,
    openModal: Boolean,
  },
  methods: {
    async createModal () {
      if (!this.locationId) {
        this.showLocation = true
        await this.getTheLocations()
      }
    },
    closeModal () {
      this.disableModal()
      this.$emit('closemodal', false)
    },
    disableModal () {
      this.startFrom = ''
      this.spotName = ''
      this.spotIdentifier = ''
      this.spotAmount = ''
      this.isStaticByDefault = false
      this.location = {}
      this.modalLoader = false
      this.spotNameErrors = []
      this.spotIdentifierErrors = []
      this.spotAmountErrors = []
      this.locationError = []
      this.spotStartFromErrors = []
    },
    onsubmit () {
      this.spotNameErrors = this.spotName ? [] : [this.$t('modals.spot.requiredSpotName')]
      this.spotIdentifierErrors = this.spotIdentifier ? [] : [this.$t('modals.spot.requiredSpotIdentifier')]
      this.spotAmountErrors = this.spotAmount ? [] : [this.$t('modals.spot.requiredSpotAmount')]

      this.startFrom = this.startFrom ? Number.parseInt(this.startFrom) : 0

      if (this.startFrom < 0) {
        this.spotStartFromErrors = [this.$t('modals.spot.spotStartFromError')]
      } else {
        this.spotStartFromErrors = []
      }

      this.spotAmount = Number.parseInt(this.spotAmount)
      if (this.spotAmount > 1000) {
        this.spotAmountErrors = [this.$t('modals.spot.spotAmountError')]
      }

      if (this.showLocation) {
        this.locationError = Object.keys(this.locationError).length !== 0 ? [] : [this.$t('modals.spot.requiredLocation')]
      } else {
        this.locationError = []
      }

      if (!this.formSpotSubmitReady) {
        return
      }
      this.modalLoader = true
      let locationId = this.locationId
      if (this.showLocation && !this.isAdmin) {
        locationId = this.editClient.event.eventId
      }
      this.$store.dispatch('createBulkSpots', {
        startFrom: this.startFrom,
        spotName: this.spotName,
        spotIdentifier: this.spotIdentifier,
        spotAmount: this.spotAmount,
        isStaticByDefault: this.isStaticByDefault,
        eventId: locationId,
      }).then((resp) => this.afterSubmit(resp.data.message))
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
        })
    },
    afterSubmit (spot) {
      this.$emit('update', spot)
      this.disableModal()
    },
    async getTheLocations () {
      if (this.$store.getters.locations.length === 0) {
        await this.$store.dispatch('getLocations')
          .then(resp => this.initlocations())
          .catch(error => {
            this.errorHandler(error.response)
            this.modalLoader = false
          })
      }
    },
    async initlocations () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.locations)
    },
  },
  computed: {
    toOpenModal () {
      if (this.openModal) {
        this.createModal()
        return true
      } else {
        return false
      }
    },
    formSpotSubmitReady () {
      return !(this.spotNameErrors.length || this.spotIdentifierErrors.length || this.spotAmountErrors.length || this.locationError.length || this.spotStartFromErrors.length)
    },
  },
}
</script>

<style scoped>

</style>
